/**
 * ResponseRobo
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseRoboCollection} from '@/model/collection/ResponseRoboCollection'

/* TODO: review generated class */
export class ResponseRobo extends Resource {
  idResponsePk: number = 0

  danfe: string | null = null
  response: string | null = null
  ehCte: boolean | null = null

  get $id() {
    return this.idResponsePk
  }
  set $id(val) {
    this.idResponsePk = val
  }

  /**
   * Gets a instance of a given ID of ResponseRobo
   */
  async getResponseRobo(id: number) {
    return await Request.get(`/admin/response-robo/${id}`)
      .name('getResponseRobo')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of ResponseRobo
   */
  static async listResponseRobo(params: any) {
    return await Request.get(`/admin/response-robo`, {params})
      .name('listResponseRobo')
      .as(ResponseRoboCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponseRobo. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponseRobo() {
    return await Request.post(`/admin/response-robo`, this)
      .name('persistResponseRobo')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponseRobo to use it in a CSV file
   */
  static async listCsvResponseRobo(params: any) {
    return await Request.get(`/admin/response-robo/csv`, {params})
      .name('listCsvResponseRobo')
      .as(ResponseRoboCollection)
      .getData()
  }
}
